import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

function PlayEntry() {
  const location = useLocation();
  const [code, setCode] = useState("");
  const [error, setError] = useState(location.state?.error || null);
  const navigate = useNavigate();
  const API = process.env.REACT_APP_API_URL;


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    const clean = code.toUpperCase().trim();
    if (!clean) return;

    try {
      const res = await axios.get(`${API}/api/sessions/validate/${clean}`);
      if (res.data.valid) {
        navigate(`/play/${clean}`);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Code invalide ou session non disponible");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 text-white flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <div className="bg-white/10 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-xl">
          <h1 className="text-2xl font-bold text-white">Rejoindre une session</h1>
          <p className="text-gray-400 text-sm mt-1">
            Entrez le <span className="font-semibold text-indigo-300">code de session</span> fourni par votre organisateur.
          </p>

          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1">
                Code de session
              </label>
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value.toUpperCase())}
                placeholder="Ex : ABCD1234"
                maxLength={12}
                className="w-full p-3 bg-gray-900 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:ring-2 focus:ring-indigo-500 focus:outline-none tracking-widest uppercase"
                autoFocus
              />
            </div>

            {error && (
              <div className="rounded-lg border border-red-500/30 bg-red-500/10 text-red-300 text-sm px-3 py-2">
                {error}
              </div>
            )}

            <button
              type="submit"
              className="w-full py-3 bg-indigo-600 hover:bg-indigo-500 rounded-lg font-semibold transition"
            >
              Jouer →
            </button>
          </form>

          <p className="text-[12px] text-gray-500 text-center mt-3">
            Besoin d’aide ? Vérifiez que le code ne contient pas d’espace.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PlayEntry;
